import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FacebookLoaderComponent } from './facebookloader.component'

@NgModule({
    imports: [CommonModule],
    declarations: [FacebookLoaderComponent],
    exports: [FacebookLoaderComponent],
})
export class FacebookLoaderModule {}
